import { getBuildPath } from '../../config/utils-config/marketGetters';

const { MARKET_NAME } = process.env.REACT_APP_MARKET_VALUES;
const BUILD_PATH = getBuildPath(MARKET_NAME);

// Used in breadcrumb
export const ROUTE_MKT_BREADCRUMB = `/${BUILD_PATH}`;
export const ROUTE_CUSTOMER_SERVICE = `/${BUILD_PATH}/customer-service/`;

// Market route
export const ROUTE_BASE = `/${BUILD_PATH}/customer-service/support`;

// Basic
export const ROUTE_HOME = `${ROUTE_BASE}/`;
export const ROUTE_GET_HELP = `${ROUTE_BASE}/t/:selectedTopicId/`;
export const ROUTE_GET_SUPPORT = `${ROUTE_BASE}/a/:suggestedTopicId/`;
export const ROUTE_PLAYGROUND = `${ROUTE_BASE}/playground/`;

// Error page CMS
export const ROUTE_ERROR_PAGE = `${ROUTE_BASE}/app-error/`;
